import {create} from "zustand";

interface HeaderState {
  headerIconClicked:boolean;
  setHeaderIconClicked: (headerIconClicked:any) => void;
  lastFocusedElement: HTMLElement | null;
  setLastFocusedElement: (el: HTMLElement | null) => void;
}

export const useStore = create<HeaderState>((set) => ({
  headerIconClicked: false,
  setHeaderIconClicked: (headerIconClicked: any) => set({ headerIconClicked }),
  lastFocusedElement: null,
  setLastFocusedElement: (el) => set({ lastFocusedElement: el }),
 }));